import { Input } from 'antd';
import { useLayerProperitesContext } from '../../../context/LayerPropertiesContext';
import './LayerProperties.scss';

const LayerTitleInput = () => {
  const { layerTitle, setState } = useLayerProperitesContext();

  return (
    <h3 className="lp-tab__title">
      <Input
        placeholder="Enter layer name"
        value={layerTitle}
        status={!String(layerTitle ?? '').trim() ? 'error' : undefined}
        aria-required
        onChange={(e) =>
          setState((prev) => ({
            ...prev,
            layerTitle: e.target.value,
            // FIX: Only update uniqueLayerName if it is a NEW layer.
            // Existing layers must keep their original unique identifier to link to GeoServer.
            uniqueLayerName: prev.isExistingLayer ? prev.uniqueLayerName : e.target.value,
          }))
        }
        className={['lp-controls__wide', 'lp-layer-title-input'].join(' ')}
      />
      {!String(layerTitle ?? '').trim() && (
        <div className="lp-layer-title-error" role="alert">
          Layer name is required
        </div>
      )}
    </h3>
  );
};

export default LayerTitleInput;
